import { FolderHistorical } from '@/types/upload';

export const getFrontTruncatedFolderPath = (history: FolderHistorical[]): string => {
  const folderNames = history.slice(1).map(f => f.name);

  let path = folderNames.join('/');
  if (path.length > 35) {
    path = '..' + path.slice(-35);
  }

  return path;
};

/**
 * Extracts the extension from a filename
 * @param filename The filename to extract extension from
 * @returns The file extension including the dot (e.g., '.txt')
 */
export const getFileExtension = (filename: string): string => {
  const lastDotIndex = filename.lastIndexOf('.');
  return lastDotIndex === -1 ? '' : filename.slice(lastDotIndex);
};

/**
 * Transforms a path to ensure it follows the required format and rules
 * @param path The input path
 * @param fileName The filename to be appended to the path
 * @returns The transformed path that follows all rules
 * @throws Error if the path contains invalid characters or mismatched extensions
 */
export const transformPath = (path: string, fileName: string): string => {
  const pathWithoutTrailingSlashes = path.replace(/[/\s]+$/, '');
  const fileExtension = getFileExtension(fileName);

  const pathParts = pathWithoutTrailingSlashes.split('/');
  const lastPart = pathParts.at(-1);
  const pathExtension = getCleanPath(getFileExtension(lastPart || ''));
  const pathHasTrailingSlash = path.at(-1) === '/';

  if (pathExtension === fileExtension && !pathHasTrailingSlash) {
    return pathWithoutTrailingSlashes;
  }

  return `${pathWithoutTrailingSlashes}/${fileName}`;
};

export const getFilename = (path: string): string => {
  return path.split('/').pop() || '';
};

export const getCleanPath = (path = '', removePrefix = false): string => {
  if (!path) return path;

  if (removePrefix) {
    return path.replace(/^(\.\/|\/)/, '');
  }

  return path;
};
